<script>
    import { slide } from 'svelte/transition';
    import { push } from 'svelte-spa-router'
    import Replacer from "./util/Replacer.svelte";
    import LandingContainer from "./landing/LandingContainer.svelte";

    let alternatives = [
        "Neinsience•Ligibiery",
        "Nurnurnars•Leraburturery",
        "N-n-scincis•Libritury",
        "Non-sense•Laborbotory",
        "Snosses•Laborse",
        "Tnonsests•Laporatey",
        "Mfomffombff•Pfafforpfy",
        "Narksank•Laoraksay",
        "Kae-kazake•Lagaxaugheig"
    ];

    let variations = [
        ['Allison', [
            'Alyson',
            'Al-essen',
            'Alagaugh',
            'Alalzen',
            'Ailisine']
        ],
        ['slithy', [
            'slythey',
            'slieisey',
            'slooy',
            'slaythay',
            'cliskie'
        ]],
        [ 'alphabet', [
            'alfabette',
            'ailphieby',
            'auluighoot',
            'altebette',
            'arlurbeter'
        ]]
    ];

    let step = 1;
    let steps = [null, null, null, null];
    let stepButtons = [null, null, null, null];

    function typewriter(node, { delay = 0, speed = 50 }) {
		const text = node.textContent;
		const duration = text.length * speed;
		return {
            delay: delay,
			duration: duration,
			tick: t => {
				const i = Math.floor(text.length * t);
				node.textContent = text.slice(0, i);
			}
		};
	}

    let wordIndex = 0;
    setInterval(function() {
        wordIndex += 1;
        if (wordIndex >= variations.length) {
            wordIndex = 0;
        }
    }, 5000);

</script>

<style>
    header {
        padding: 1em;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    header a {
        color: black;
        text-decoration: underline;
    }
    h1 {
        font-size: 6vw;
        margin-bottom: 0;
    }
    @media screen and (max-width: 39.999em) {
        .landing-body {
            margin-left: 0.25rem;
            margin-right: 0.25rem;
        }
        .right {
            padding-left: 10%;
        }
        .left {
            padding-right: 10%;
        }
        .capimg .caption {
            font-size: 0.5rem;
        }
    }
    @media screen and (min-width: 40em) {
        .landing-body {
            margin-left: 10%;
            margin-right: 10%;
        }
        .right {
            padding-left: 30%;
        }
        .left {
            padding-right: 30%;
        }
        .capimg .caption {
            font-size: 0.7rem;
        }
    }
    .landing-body {
        height: 100%;
    }
    .diagram-container {
        display: flex;
        height: 18vw;
        justify-content: space-between;
        align-items: center;
        margin-top: 2.5rem;
        margin-bottom: 2.5rem;
    }
    .capimg img {
        display: block;
        height: 100%;
    }
    .diagram-container .input, .diagram-container .output {
        display: flex;
        flex-direction: column;
        text-transform: uppercase;
        font-size: 1.5vw;
        letter-spacing: 0.05em;
        justify-content: center;
        height: 100%;
        width: 100%;
        padding: 0.5em;
    }
    .input .item {
        width: 100%;
        padding: 0.25rem;
        margin: 0;
    }
    .capimg {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        height: 100%;
    }
    .capimg .caption {
        margin-top: 0.25rem;
        text-transform: uppercase;
        margin-top: 0.5rem;
        text-align: center;
    }
    p {
        margin: 0;
    }
    div[slot="content"] a {
        text-decoration: underline;
        color: #000;
    }
</style>

<header>
    <h1><Replacer content="Nonsense•Laboratory" alternatives={alternatives} /></h1>
    <a href="#/menu">Skip introduction</a>
</header>

<div class="landing-body">

    {#if step >= 1}
    <div class="right" bind:this={steps[0]}>
        <LandingContainer on:click={() => { step = 2; }} scroll={false} bind:actionButton={stepButtons[0]}>
            <div slot="content">
                The Nonsense Laboratory uses machine learning to let you poke at, mangle, and play with the spelling of words.
            </div>
            <span slot="buttonText">Next</span>
        </LandingContainer>
    </div>
    {/if}

    {#if step >= 2}
    <div class="left" bind:this={steps[1]}>
        <LandingContainer on:click={() => { step = 3; }} lineTo={stepButtons[0]} bind:actionButton={stepButtons[1]}>
            <div slot="content">
                It is based on
                <a href="http://github.com/aparrish/pincelate/" target="_blank">Pincelate</a>,
                a machine learning model that breaks down any English word into its phonetics.
                You can put in made up words, nonsense words, or just random letters and
                Pincelate will try to sound them out.
            </div>
            <span slot="buttonText">Next</span>
        </LandingContainer>
    </div>
    {/if}

    {#if step >= 3}
    <div bind:this={steps[2]}>
        <LandingContainer on:click={() => { step = 4; }} lineTo={stepButtons[1]} bind:actionButton={stepButtons[2]}>
            <div slot="content">
                The model works by translating letters into <em>mouth movements</em> and back. 
                <div class="diagram-container">
                    <div class="input">
                        <div class="item box white lev3">
                            {#key wordIndex}<span in:typewriter={{delay: 1000, speed: 100}}>{variations[wordIndex][0]}</span>{/key}|
                        </div>
                    </div>
                    <img src="assets/svg/diagram-arrow-right.svg" style="width: 1.25rem;" alt="right arrow"/>
                    <div class="capimg">
                        <img src="assets/images/diagram-network1.apng" alt="animated diagram of neural network"/>
                        <div class="caption">Neural network</div>
                    </div>
                    <img src="assets/svg/diagram-arrow-right.svg" style="width: 1.25rem;" alt="right arrow"/>
                    <div class="capimg">
                        <img src="assets/images/diagram-mouthshapes.apng" alt="animated icons of mouth shapes"/>
                        <div class="caption">Phonetic features</div>
                    </div>
                    <img src="assets/svg/diagram-arrow-right.svg" style="width: 1.25rem;" alt="right arrow"/>
                    <div class="capimg">
                        <img src="assets/images/diagram-network2.apng" alt="animated diagram of neural network"/>
                        <div class="caption">Neural network</div>
                    </div>
                    <img src="assets/svg/diagram-arrow-right.svg" style="width: 1.25rem;" alt="right arrow"/>
                    <div class="output">
                        {#key wordIndex}
                            {#each variations[wordIndex][1] as word}
                                <div class="item" in:typewriter={{delay: 1500, speed: 100}} out:slide>{word}</div>
                            {/each}
                        {/key}
                    </div>
                </div>
                The tools in the Nonsense Laboratory let you manipulate these letters
                and mouth movements to make strange and new words... a bit like playing
                a musical instrument or modeling clay.
            </div>
            <span slot="buttonText">Next</span>
        </LandingContainer>
    </div>
    {/if}

    {#if step >= 4}
    <div class="right" bind:this={steps[3]}>
        <LandingContainer on:click={() => { push("/menu") }} lineTo={stepButtons[2]} bind:actionButton={stepButtons[3]}>
            <p slot="content">
                You can use your word creations in stories, poems or just say them aloud with friends.
                Start making nonsense!
            </p>
            <span slot="buttonText">Make Nonsense</span>
        </LandingContainer>
    </div>
    {/if}

</div>
<div id="bottom">
</div>